var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8011 22.75H2.46378V9H18.8011M15.3002 0.25V2.75H5.96464V0.25H3.63073V2.75H2.46378C1.18014 2.75 0.129883 3.875 0.129883 5.25V22.75C0.129883 23.413 0.375775 24.0489 0.813467 24.5178C1.25116 24.9866 1.8448 25.25 2.46378 25.25H18.8011C20.0964 25.25 21.135 24.1375 21.135 22.75V5.25C21.135 4.58696 20.8891 3.95107 20.4514 3.48223C20.0137 3.01339 19.4201 2.75 18.8011 2.75H17.6341V0.25M9.32545 14H5.11276L8.52026 16.6375L7.22494 20.95L10.6324 18.2875L14.0399 20.95L12.733 16.65L16.1404 14H11.9394L10.6324 9.7L9.32545 14Z",
    fill: "#0D9C7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingDetailIcon);
export default __webpack_public_path__ + "static/media/bookingDetailIcon.1c396940da86d3e858b3ab84bbe5f330.svg";
export { ForwardRef as ReactComponent };